import { Slide } from '../types/slide';
import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ResponseRequestEvent } from '@softline/core';
import {
  SOFTLINE_API_POS_DISPLAY_LOCKED_SLIDE_SHOW,
  SOFTLINE_API_POS_DISPLAY_SLIDE_SHOW,
  SOFTLINE_API_POS_DISPLAY_SLIDE_SHOW_IMAGE,
} from '../pos-display.api';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

export interface ISideShowRepository {
  getSlides(): Promise<Slide[]>;
  getSlideImage(imageKey: number): Promise<any>;
}

@Injectable()
export class SlideShowRepository implements ISideShowRepository {
  readonly dataAccess = inject(ApiDataAccess);
  readonly http = inject(HttpClient);

  async getSlides(): Promise<Slide[]> {
    return await this.dataAccess.get({ path: SOFTLINE_API_POS_DISPLAY_SLIDE_SHOW });
  }

  async getLockedSlides(): Promise<Slide[]> {
    return await this.dataAccess.get({
      path: SOFTLINE_API_POS_DISPLAY_LOCKED_SLIDE_SHOW,
    });
  }

  async getSlideImage(imageKey: number): Promise<any> {
    return (
      (await lastValueFrom(
        this.dataAccess.download(
          {
            path: SOFTLINE_API_POS_DISPLAY_SLIDE_SHOW_IMAGE,
            pathParams: { key: imageKey },
          },
          undefined,
          { responseType: 'blob' }
        )
      )) as ResponseRequestEvent<Blob>
    ).response;
  }
}
